import { AccredibleApiService } from '@accredible-frontend-v2/services/api';
import { Injectable, signal } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import {
  SlackChannel,
  SlackChannelsResponse,
  SlackMessage,
  SlackMessagePayload,
} from '../entities/slack.model';

@Injectable({ providedIn: 'root' })
export class SlackApiService extends AccredibleApiService {
  readonly channels = signal<SlackChannel[]>(null);

  authenticateSlack(code: string, session_id: string): Observable<boolean> {
    return this._post('/v1/slack/auth', { code, session_id }).pipe(
      map((res: { success: boolean }) => this._handleResponse(res, 'success')),
      catchError((err) => this._handleError(err)),
    );
  }

  getChannels(session_id?: string): Observable<SlackChannel[]> {
    if (this.channels()?.length) {
      return of(this.channels());
    }

    return this._get(
      `/v1/slack/conversations${session_id ? `?session_id=${session_id}` : ''}`,
    ).pipe(
      map((res: SlackChannelsResponse) => this._handleResponse(res, 'channels')),
      tap((conversations) => this.channels.set(conversations)),
      catchError((err) => throwError(() => err)),
    );
  }

  sendMessage(payload: SlackMessagePayload): Observable<SlackMessage> {
    return this._post('/v1/slack/messages', payload).pipe(
      map((res) => this._handleResponse(res)),
      catchError((err) => this._handleError(err)),
    );
  }
}
